<template>
  <div id="index">
    <Header ref="header"></Header>
    <div class="productDetails" :class="morenDiv == false ? 'none':''">
     <div class="productDetailsBox">
        <div class="productDetailsBox1">
          <img :src="goodsDetails.images" class="productDetailsImg">
          <ul>
            <!-- goodsDetails -->
            <li><img src="../assets/img/productDetailsIcon.png" alt=""> {{goodsDetails.companyName}}</li>
            <li><h6> <span>价格电议</span> </h6></li>
            <li>商品名称：<b>{{goodsDetails.goodName}}</b></li>
            <li>存　　量：<b>9999千克</b></li>
            <li>产　　区：<b>{{goodsDetails.chanqu}}</b></li>
            <li><p>产　　地：{{goodsDetails.chandi}}</p></li>
            <li><p>规格等级： {{goodsDetails.skuName}} </p></li>
            <li><p>质量要求： {{goodsDetails.content}} </p></li>
            <li><p>联系方式：{{goodsDetails.phone}}（微信公众号联系客服人员可索取小样）</p></li>
          </ul>
        </div>
        <div class="productDetailsBox2">
          <ul>
            <li v-for="item in goodsDetails.imagesList" @click="changeImg(item)"><img :src="item.image" /></li>
          </ul>
        </div>
     </div>
    </div>
    <!-- 推荐产品 -->
    <div class="index5">
      <div class="index5Box" style="width:1220px;height:400px">
        <h2><b>&nbsp;&nbsp;推荐产品</b></h2>
        <ul>
          <li v-for="(item,index) in othersList.slice(0,5)" :key="item.id">
            <img :src="item.goodsImage"  @click="goProductDetails(item.id)"/>
            <p @click="goProductDetails(item.id)">{{item.goodName}}&nbsp;{{item.chandi}}</p>
            <p v-show="goodsShowIndex != index"><button @click="showPhone(index)">价格电议</button></p>
            <p class="index5BoxPhoneP" v-show="goodsShowIndex == index">{{item.phone}}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer">
      <div class="foot">
        <ul>
          <li>电话：0558-5858131</li>
          <li>地址：亳州市谯城区亳芜现代产业园区希夷大道与月季路交叉口</li>
          <li>安徽广盛堂中药饮片有限公司 版权所有 免责声明 皖ICP备18026442号</li>
          <li>皖公网安备 3416020200060号</li>
        </ul>
        <img src="../assets/img/footerImg.jpg" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/header'
export default {
  components: {
    Header
  },
  data() {
    return {
      phoneDialog:false,
      phone:'',
      morenDiv:true,
      showLogin:true,
      EWMImg:false,
      EWMButton:true,
      productDetailsImg:require('../assets/img/productDetailsIconImg.png'),
      productImgList:[
        {id:"001",imgUrl:require('../assets/img/productDetailsImg1.png')},
        {id:"002",imgUrl:require('../assets/img/productDetailsImg2.png')},
        {id:"003",imgUrl:require('../assets/img/productDetailsImg3.png')},
        {id:"003",imgUrl:require('../assets/img/productDetailsImg4.png')},
        {id:"003",imgUrl:require('../assets/img/productDetailsImg5.png')}
      ],
      goodsDetails:{},
      othersList:[],
      goodsShowIndex:-1
    }
  },
  mounted() {
    if(this.$cookie.get('account') == null){
      this.showLogin = true
    }else{
      this.showLogin = false
    }
    this.getProductDetails();
    this.getOtherList();
  },
  methods: {
    getProductDetails(){
      this.$fetch('getGoodsDetails',{id:this.$route.query.id}).then(res => {
       this.goodsDetails = res.result;
      })
    },
    getOtherList(){
      this.$fetch('getOtherList').then(res => {
       this.othersList = res.result;
      })
    },
    goProductDetails(id){
      this.$fetch('getGoodsDetails',{id:id}).then(res => {
        this.goodsDetails = res.result;
      })
    },
    changeImg(data){
      this.goodsDetails.images = data.image;
    },
    showPhone(index){
      this.goodsShowIndex = index;
    }
  }
}
</script>
<style>
  @import "../assets/css/style.css";
</style>



// WEBPACK FOOTER //
// src/components/productDetails.vue